import { cur } from '@/lib/currency';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

const PIE_COLORS = ['#F5841F', '#22C55E', '#0EA5E9', '#EF4444', '#F59E0B', '#8B5CF6', '#94A3B8'];

// Top 6 categories + "Other" so slices and labels never crowd.
const topCategories = (obj) => {
  const rows = Object.entries(obj || {}).map(([k, v]) => ({ name: k.replace(/_/g, ' '), value: Number(v) || 0 }))
    .filter((r) => r.value > 0).sort((a, b) => b.value - a.value);
  if (rows.length <= 7) return rows;
  return [...rows.slice(0, 6), { name: 'Other', value: rows.slice(6).reduce((s, r) => s + r.value, 0) }];
};

export default function QuickChartsWidget({ stats, cardClass = '' }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {stats.expense_by_category && Object.keys(stats.expense_by_category).length > 0 && (
        <Card className={cardClass}>
          <CardHeader className="pb-2"><CardTitle className="font-outfit text-base">Expense Distribution</CardTitle></CardHeader>
          <CardContent>
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie
                  data={topCategories(stats.expense_by_category)}
                  cx="40%" cy="50%" outerRadius={75} innerRadius={40} dataKey="value"
                >
                  {topCategories(stats.expense_by_category).map((_, i) => <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
                </Pie>
                <Legend layout="vertical" align="right" verticalAlign="middle" iconSize={8}
                  formatter={(v) => <span className="text-xs">{String(v).length > 18 ? `${String(v).slice(0, 17)}…` : v}</span>} />
                <Tooltip formatter={(v) => `${cur()} ${Number(v).toFixed(0)}`} />
              </PieChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      )}
      <Card className={cardClass}>
        <CardHeader className="pb-2"><CardTitle className="font-outfit text-base">Sales vs Expenses</CardTitle></CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={[
              { name: 'Sales', amount: stats.total_sales || 0 },
              { name: 'Expenses', amount: stats.total_expenses || 0 },
              { name: 'Supplier', amount: stats.total_supplier_payments || 0 },
              { name: 'Profit', amount: stats.net_profit || 0 },
            ]}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 10 }} width={44} tickFormatter={(v) => (Math.abs(v) >= 1000 ? `${(v / 1000).toFixed(0)}k` : v)} />
              <Tooltip formatter={(v) => `${cur()} ${v.toFixed(0)}`} />
              <Bar dataKey="amount" radius={[6, 6, 0, 0]}>
                {[
                  { fill: '#22C55E' },
                  { fill: '#EF4444' },
                  { fill: '#0EA5E9' },
                  { fill: (stats.net_profit || 0) >= 0 ? '#22C55E' : '#EF4444' },
                ].map((c, i) => <Cell key={i} fill={c.fill} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
}
